import { Component } from "@angular/core";
import { CartService } from "../../../services/cart.service";
import { CartDto } from "../../../dtos/CartDto";
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { ToastService } from "../../../services/toast.service";

@Component({
  selector: 'app-cart',
  standalone: false,
  templateUrl: './app-cart.component.html',
  styleUrl: './app-cart.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class CartComponent {
    cart: CartDto = new CartDto();
    faPlus = faPlus;
    faMinus = faMinus;

    constructor(
        private service: CartService,
        private toastService: ToastService
    ) {
        const cartId = localStorage.getItem('cartId');
        if(cartId) {
            this.service.getCart(cartId).subscribe((value: any) => { 
                this.cart = value;
            });
        }
    }

    async addToCart(productId: string) {
        try {
            this.service.addToCart(productId).subscribe(cart => {
                this.cart = cart;
                this.showSuccessToast('added');
            });
        } catch (error: any) {
            console.log(error);
            this.showFailureToast('add');
        }
    }

    async removeFromCart(productId: string) {
        try {
            this.service.removeFromCart(productId).subscribe(cart => {
                this.cart = cart;
                this.showSuccessToast('removed');
            });
        } catch (error: any) {
            console.log(error);
            this.showFailureToast('remove');
        }
    }

    showSuccessToast(operation: string) {
        this.toastService.show(`Successfully ${operation} item to cart.`, { header: `Product ${operation}`, classname: 'bg-success text-light' });
    }

    showFailureToast(operation: string) {
        this.toastService.show('Please message us for support.', { header: `Failed to ${operation} Product`, classname: 'bg-danger text-light' });
    }
}
